module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Airplay-c8fba0fcade2ae8b0641b2ab4badb505.svg";